var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"radios-group"},_vm._l((_vm.button_list),function(item){return _c('span',{key:item.label,class:{ activeType: _vm.active === item.label },on:{"click":() => {
				_vm.$emit('ok', item.label);
			}}},[_vm._v(_vm._s(item.name))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }